module.exports = __webpack_public_path__ + "img/csv.a7899ff3.svg";